import { InfoOutlined } from '@mui/icons-material';
import { Card, CardContent, Stack, Tooltip, Typography } from '@mui/material';
import Grid from '@mui/material/Grid2';

import { CONTENT_LABELS, CONTENT_ORDER, type HistoryCurrentLevels } from '@/lib/api/bgt-history';

interface Props {
  levels: HistoryCurrentLevels;
}

/**
 * 의뢰서 5-2 탭2 난이도 카드 (P5-4 A안).
 *
 * BGT UserTestTypeTestLevel은 현재 시점만 보관하므로 변경 이력 표시 불가.
 * 추이 그래프 대신 5종 카드로 현재 난이도만 노출 + 변경 시각 미상 안내.
 * v2에서 admin_user_level_history 도입 시 추이 그래프로 교체 예정.
 */
export function LevelCards({ levels }: Props) {
  return (
    <Card variant="outlined">
      <CardContent>
        <Stack direction="row" justifyContent="space-between" alignItems="center" sx={{ mb: 1.5 }}>
          <Stack direction="row" spacing={0.5} alignItems="center">
            <Typography variant="subtitle1" fontWeight={700}>
              난이도 (현재 시점)
            </Typography>
            <Tooltip
              title="BGT가 난이도 변경 이력을 보관하지 않아 변경 시각·이전 값은 표시할 수 없습니다. 추이는 v2에서 도입 예정입니다."
              arrow
            >
              <InfoOutlined sx={{ fontSize: 16, color: 'text.disabled' }} />
            </Tooltip>
          </Stack>
        </Stack>
        <Grid container spacing={1}>
          {CONTENT_ORDER.map((t) => {
            const v = levels[t];
            return (
              <Grid size={{ xs: 6, sm: 4, md: 2.4 }} key={t}>
                <Stack
                  spacing={0.25}
                  sx={{
                    p: 1,
                    border: 1,
                    borderColor: 'divider',
                    borderRadius: 1,
                    textAlign: 'center',
                  }}
                >
                  <Typography variant="caption" color="text.secondary">
                    {CONTENT_LABELS[t]}
                  </Typography>
                  <Typography variant="body1" fontWeight={600}>
                    {v === undefined ? '—' : `Lv ${v}`}
                  </Typography>
                </Stack>
              </Grid>
            );
          })}
        </Grid>
      </CardContent>
    </Card>
  );
}
